module.exports = __webpack_public_path__ + "static/media/kocka3POMOZIBA.576250b1.png";